import { render } from "./InputRadio.vue?vue&type=template&id=7c9d36c0"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=7c9d36c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__